<template>
    <div  @mouseleave="volumeIn = false" class="_volume-wrapper">
        <div class="_volume_icon" @mouseenter="volumeIn = true">
            <Volume @click="toggleMute" />
        </div>
        <div class="_volume-slider" :class="{'_volume-slider-in': volumeIn}">
            <VolumeSlider />
        </div>
    </div>
</template>

<script>
    import Volume from '@icons/Volume';
    import VolumeSlider from './VolumeSlider';

    export default {
        name: "VolumeControl",
        components:{
            VolumeSlider, Volume
        },

        props:{
            open:{
                type: Boolean,
                required: false
            }
        },

        data:()=>({
            volumeIn: false
        }),

        methods:{
            toggleMute(){
                this.$emit('toggleMute');
            },
        }
    }
</script>

<style scoped>
._volume_icon {
    float: left;
    width: 25px;
}
    ._volume-slider {
        float: left;
        opacity: 0;
        z-index: -1;
        overflow: hidden;
        width: 70px;
        transition: 0.1s linear opacity;
    }

    ._volume-slider-in {
        opacity: 1;
        z-index: 1;
    }

    ._volume-wrapper {
        /*cursor: pointer;*/
    }
</style>